export const ReportTypeConstants = {
  SalesReport: "Sales",
};

export const FirebaseCollectionName = {
  Reports: "ReportStatus",
  Announcements: "Announcements",
};

export const ReportStatuses = {
  Working: "Working",
  Accepted: "Accepted",
  Submitted: "Submitted",
  Reopened: "Reopened",
};
